import { CommonModule } from "@angular/common";
import { Component, HostListener, ElementRef, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router, RouterModule } from "@angular/router";
import { HideScrollNavService } from "../../services/hidescrollnav.service";
import { NavService } from "../../services/nav.service";
import { SearchService } from "../../services/search.service";
import { BreadcrumbComponent } from "../breadcrumb/breadcrumb.component";
import { AuthService } from "../../services/auth.service";
import { ALERT_ROUTE, USER_MANAGEMENT_ROUTE } from "../../constants/constants";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-header",
  imports: [FormsModule, RouterModule, CommonModule, BreadcrumbComponent, TranslateModule],
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent {
  @ViewChild('profileMenu') profileMenuRef!: ElementRef;
  public isFlip: boolean = false;
  public isSearchOpen: boolean = false;
  public open: boolean = false;
  public isProfileMenuOpen: boolean = false;
  public notificationCount: number = 5;

  constructor(
    public navService: NavService,
    public hideScrollNavService: HideScrollNavService,
    public searchService: SearchService,
    private router: Router,
    private authService: AuthService
  ) {}

  sidebarToggle() {
    this.navService.collapseSidebar = !this.navService.collapseSidebar;
  }

  goToProfile() {
    this.router.navigate(["profile"]);
  }

  goToAlerts() {
    this.router.navigate([ALERT_ROUTE]);
  }

  goToCreateUser() {
    this.router.navigate([USER_MANAGEMENT_ROUTE]);
  }

  logOut() {
    this.authService.logoutApi().subscribe({
      next: () => {
        this.authService.logout();
      },
      error: (error) => {
        console.error('Error on logout', error);
        // Even if API call fails, logout locally
        this.authService.logout();
      }
    });
  }

  toggleProfileMenu(event: Event) {
    event.stopPropagation();
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
  }

  closeProfileMenu() {
    this.isProfileMenuOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.isProfileMenuOpen && this.profileMenuRef && !this.profileMenuRef.nativeElement.contains(event.target)) {
      this.closeProfileMenu();
    }
  }

  onProfileClick() {
    this.closeProfileMenu();
    this.goToProfile();
  }

  onLogoutClick() {
    this.closeProfileMenu();
    this.logOut();
  }

  /**
   * Check if the current user is an admin
   * Used to conditionally show/hide UI elements
   */
  isAdmin(): boolean {
    return this.authService.isAdmin();
  }
}
